import { safeParse } from './safeParse'

export const parseFromLocalStorage = (key, defaultValue = {}) => {
  // @ts-ignore
  return safeParse(window.localStorage.getItem(key), defaultValue)
}
